export default __webpack_public_path__ + "static/media/retro1.d8a9297b.jpg";